module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /home/runner/work/RS-rydges2018-docker/RS-rydges2018-docker/wp-content/themes/rydges/node_modules/axios/index.js
// module id = 7
// module chunks = 0